import React, { useState, useEffect } from "react";
import { Button, Tab, Icon, Container } from "semantic-ui-react";
import { BasicModal } from "../../../../components/Shared";
import { ListQuiz } from "../../../../components/Admin/QuizComponents/ListQuiz/ListQuiz";
import { QuizForm } from "../../../../components/Admin/QuizComponents/QuizForm/QuizForm";
import "./PageTeacher_Quiz.scss";

export function Page_Teacher_Quiz() {
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);
  const [showSteps, setShowSteps] = useState(false);

  const onOpenCloseModal = () => setShowModal((prev) => !prev);
  const onReload = () => setReload((prev) => !prev);

  useEffect(() => {
    localStorage.removeItem("quizImage");
  }, []);

  // -----------------------
  // Pasos para la sección de Quiz
  // -----------------------
  const steps = [
    {
      title: "Paso 1",
      description: // Cambiado de 'desc' a 'description'
        'Estos cuestionarios de Evaluación están compuestos por preguntas que se abren a 4 posibles respuestas, siendo sólo una la verdadera.',
    },
    {
      title: "Paso 2",
      description: // Cambiado de 'desc' a 'description'
        "Pulsando “Nueva Evaluación”, puedes crear tus propios cuestionarios y asignarlos a los itinerarios que necesites evaluar.",
    },
    {
      title: "Paso 3",
      description: // Cambiado de 'desc' a 'description'
        "Siempre puedes editar para añadir o modificar preguntas y respuestas. En la opción “Estadísticas” podrás comprobar los resultados obtenidos por tus alumnos.",
    },
  ];

  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          <ListQuiz reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <>
      <div className="quiz-page"> {/* Clase ajustada a kebab-case */}
        <Container className="ui-materials">
          {/* -------------------------------------------------------------------------------- */}
          {/* 1) Sección introductoria con título y descripción */}
          {/* -------------------------------------------------------------------------------- */}
          <div className="intro-header"> {/* Clase ajustada a kebab-case */}
            <div className="intro-sections"> {/* Clase ajustada a kebab-case */}
              <div className="intro-section rutas-creadas"> {/* Clase ajustada a kebab-case, y se añade intro-section */}
                <h2 className="intro-title"> {/* Clases existentes en Page_UIMaterials.scss */}
                  En EVALUACIONES tienes algunos cuestionarios ya creados
                  destinados a evaluar el aprendizaje del alumnado tras una
                  sesión en una ESCENA o ITINERARIO.
                </h2>
                <p className="intro-description"> {/* Clases existentes en Page_UIMaterials.scss */}
                  También puedes crear tus propios cuestionarios de evaluación de
                  forma sencilla.
                </p>
                <hr className="intro-divider" /> {/* Clases existentes en Page_UIMaterials.scss */}
              </div>
            </div>

            {/** Icono de información que muestra/oculta los pasos */}
            <div
              className="info-toggle" 
              onClick={() => setShowSteps((prev) => !prev)}
              title={showSteps ? "Ocultar información" : "Mostrar información"}
            >
              <Icon name="info" size="large" />
            </div>
          </div>

          {/* -------------------------------------------------------------------------------- */}
          {/* 2) Bloque de pasos (se renderiza solo si showSteps===true) */}
          {/* -------------------------------------------------------------------------------- */}
          {showSteps && (
            <div className="quiz-steps"> {/* Clase ajustada a kebab-case */}
              {steps.map((s, i) => (
                <div key={i} className="intro-section step"> {/* Clase existente, se añade intro-section */}
                  <h2 className="intro-title">{s.title}</h2> {/* Clases existentes en Page_UIMaterials.scss */}
                  <p className="intro-description">{s.description}</p> {/* Clases existentes en Page_UIMaterials.scss */}
                  <hr className="intro-divider" /> {/* Clases existentes en Page_UIMaterials.scss */}
                </div>
              ))}
            </div>
          )}

          {/* -------------------------------------------------------------------------------- */}
          {/* 3) Botón “NUEVA EVALUACIÓN” */}
          {/* -------------------------------------------------------------------------------- */}
          <div className="quiz-page__add"> {/* Clase ajustada a kebab-case */}
            <Button
              className="quiz-page__add__button" 
              primary
              onClick={onOpenCloseModal}
            >
              CREAR EVALUACIÓN
            </Button>
          </div>

          {/* -------------------------------------------------------------------------------- */}
          {/* 4) Lista de quizzes mediante Tab de Semantic UI */}
          {/* -------------------------------------------------------------------------------- */}
          <Tab menu={{ secondary: true }} panes={panes} />
        </Container>
      </div>

      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title="Crear nueva Evaluación"
        size="large"
      >
        <QuizForm onClose={onOpenCloseModal} onReload={onReload} />
      </BasicModal>
    </>
  );
}